import { Spinner } from 'components/Elements';
import { lazyImport } from 'utils/lazyImport';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const { Dashboard } = lazyImport(() => import('features/misc'), 'Dashboard');
const { Profile } = lazyImport(() => import('features/users'), 'Profile');
const { FarmsRoutes } = lazyImport(() => import('features/farms'), 'FarmsRoutes');
const { LandsRoutes } = lazyImport(() => import('features/lands'), 'LandsRoutes');
const { GroupFundingRoutes } = lazyImport(
  () => import('features/groupFunding'),
  'GroupFundingRoutes'
);
const { OpenMarketRoutes } = lazyImport(() => import('features/openmarket'), 'OpenMarketRoutes');
const { SaccosRoutes } = lazyImport(() => import('features/saccos'), 'SaccosRoutes');

const App = () => {
  return (
    <>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </>
  );
};

export const protectedRoutes = [
  {
    path: '/app',
    element: <App />,
    children: [
      { path: '/app/account', element: <Profile /> },
      { path: '/app/lands/*', element: <LandsRoutes /> },
      { path: '/app/farms/*', element: <FarmsRoutes /> },
      { path: '/app/funding/*', element: <GroupFundingRoutes /> },
      { path: '/app/market/*', element: <OpenMarketRoutes /> },
      { path: '/app/sacco/*', element: <SaccosRoutes /> },
      { path: '/app/', element: <Dashboard /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },
];
